<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col offset-md="1" offset-lg="2">
        <Container :paddedTopBottom="false">
          <h2>Rob Verdel</h2>
          <p>
            Mijn interesse in sport, bewegen en het menselijk lichaam begon al
            vroeg. Na het CIOS in Arnhem ben ik fysiotherapie gaan studeren.
            Vervolgens heb ik meerdere jaren als fysiotherapeut gewerkt, waarvan
            een groot deel in Zwitserland. In mijn werk merkte ik dat ik steeds
            vaker verder wilde kijken dan alleen de plek waar een klacht zich
            bevindt. Dat bracht mij bij de osteopathie en de opleiding aan
            College Sutherland in Amsterdam.
          </p>
          <p>
            Wat mij aanspreekt in de osteopathie is het kijken naar het lichaam
            als één geheel. Verschillende structuren en systemen kunnen elkaar
            beïnvloeden en de plek waar iemand pijn ervaart, hoeft niet altijd
            de plek te zijn waar het probleem is ontstaan.
          </p>
          <p>
            Mijn jarenlange ervaring als fysiotherapeut vormt daarbij een
            belangrijke basis. Ik heb veel ervaring met onder andere rug-, nek-,
            schouder-, bekken- en heupklachten, sportblessures en uitstralende
            pijn. Hierdoor kan ik mijn kennis uit de fysiotherapie combineren
            met de bredere benadering vanuit de osteopathie.
          </p>
          <p>
            Als behandelaar ben ik betrokken, nieuwsgierig en praktisch
            ingesteld. Ik luister goed naar het verhaal van de patiënt en zoek
            samen naar een behandeling die past bij de persoon en zijn of haar
            klacht.
          </p>
          <p>
            Ook buiten mijn werk speelt sport een belangrijke rol in mijn leven.
            Ik train meerdere keren per week en neem mijn interesse in sport,
            bewegen en gezondheid mee in mijn manier van behandelen.
          </p>
          <img src="../../assets/team/rob.jpeg" alt="Rob Verdel" />
        </Container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Container from "../../components/Container.vue";

export default {
  name: "Rob",
  components: { Container }
};
</script>

<style lang="less" scoped>
h2 {
  font-size: 2rem;
  text-transform: uppercase;
  margin-bottom: 1rem;
  margin-top: 3rem;
}

img {
  max-width: 100%;
  max-height: 480px;
  width: auto;
}
</style>
